
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demos",
      function () {
        return require("private-next-pages/demos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demos"])
      });
    }
  